import { z } from 'zod';

export const AnalogSchema = z.object({
  smiles: z.string(),
  description: z.string().optional(),
  name: z.string().optional(),
});
export type Analog = z.infer<typeof AnalogSchema>;
